<ng-container *ngIf="showHeader" class="div-print">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Malla Societaria</h1>
                <button mat-flat-button class="custom-button-primary no-print"
                    [printTitle]='"MallaSocietaria_"+(rut | rutFormat)+"_"+today' [useExistingCss]="true"
                    printSectionId="print-section" ngxPrint>
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app"
                        class="icon-download"></mat-icon>
                    Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong>{{content.MallaSocietariaReporte.DatosBasicosSolicitud.Rut | number:'1.0-0'}}-{{content.MallaSocietariaReporte.DatosBasicosSolicitud.DV | uppercase}}
                    </mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12 d-flex justify-content-end mb-3">
                <button *ngIf="validaPermisoCrear()" mat-flat-button type="button" class="custom-button-secondary no-print" (click)="crearReport(rut)">
                    <mat-icon aria-hidden="false" aria-label="Icono de actualizar" class="scale-150">refresh</mat-icon>
                    Actualizar
                </button>
            </div>
            <div class="col-12">
                <mat-card>
                    <mat-card-content>

                        <div #chartContainer class="myChart no-print" id="chartContainer"></div>

                        <div id="print-section-malla" class="div-print">
                            <div class="nested-table-container">
                                <div class="nested-table-row print-table-header">
                                    <div class="rs-nested-table-cl">Razon Social</div>
                                    
                                    <div class="type-and-rut">
                                        <div>Tipo</div>
                                        <div>RUT</div>
                                    </div>
                                </div>
                            
                                <br>
                            
                                <app-print-transunion-table [dataSource]="dataOrgPrint"></app-print-transunion-table>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>
